module.exports = __webpack_public_path__ + "static/playroom1-c6755b97afe7fa1b1808df91cb42ce17.png";